module.exports = __webpack_public_path__ + "img/midBox_mark.e45a055f.png";